module.exports = __webpack_public_path__ + "img/banner_pk10.9573fb09.jpg";